export function replaceHiddenInputValues() {
    const marketoSourceCampaign =
        document.querySelector("body")?.getAttribute("data-source-campaign") ?? "";

    const hiddenInputs = document.querySelectorAll<HTMLInputElement>(
        'input[type="hidden"][value="SOURCECAMPAIGN"]'
    );

    hiddenInputs.forEach((input) => {
        input.value = marketoSourceCampaign;
    });
}

